export default __webpack_public_path__ + "static/media/azad-uni.d066ba4b.png";